export enum FeatureToggle {
  IppAiAgent = 'rt_ipp_ai_agent',
  RetailerAgent = 'rt_retailer_agent',
  IppCookieDetectionEnabled = 'rt_ipp_cookie_detection_enabled',
}
